module.exports = __webpack_public_path__ + "9c46095118380d38f12e67c916b427f9.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/fonts/Montserrat-Regular.ttf
// module id = 1898
// module chunks = 0